var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{attrs:{"api-key":"gh7826upfjy7avgv166q91o8iks5dgygcf9dhvbb5d2d2ks0","init":_vm.config,"value":_vm.value},on:{"input":_vm.updateValue,"onClick":_vm.handleOnClick,"onKeyPress":_vm.handleKeyPress}})}
var staticRenderFns = []

export { render, staticRenderFns }